const RESTAPI_BASE = import.meta.env.VITE_APP_RESTAPI || "https://demo.routaapi.com/"
class JobService {
    constructor() {
        this.activeJobs = new Map()
    }

    startJob(jobId, token, onComplete, onError) {
        if (this.activeJobs.has(jobId)) {
            return
        }

        const url = `${RESTAPI_BASE}route-optimization/job/${jobId}/stream?token=${encodeURIComponent(token)}`

        const eventSource = new EventSource(url)

        const timeout = setTimeout(() => {
            this.cleanup(jobId)
        }, 600000)

        eventSource.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data)
                if (data.status === 'SUCCEEDED') {
                    this.cleanup(jobId)
                    onComplete(data.resultData)
                } else if (data.status === 'FAILED') {
                    this.cleanup(jobId)
                    onError(data.errorMessage)
                }
            } catch (err) {
                this.cleanup(jobId)
                onError('Parse error')
            }
        }

        eventSource.onerror = (error) => {
            this.cleanup(jobId)
            onError('Connection error')
        }

        this.activeJobs.set(jobId, { eventSource, timeout })
    }

    cleanup(jobId) {
        const job = this.activeJobs.get(jobId)
        if (job) {
            job.eventSource.close()
            clearTimeout(job.timeout)
            this.activeJobs.delete(jobId)
        }
    }

    cancelJob(jobId) {
        this.cleanup(jobId)
    }

    cancelAllJobs() {
        for (const jobId of this.activeJobs.keys()) {
            this.cleanup(jobId)
        }
    }

    isJobActive(jobId) {
        return this.activeJobs.has(jobId)
    }
}

export default new JobService()
